import { setSportId } from "../../helpers";
import { fillEmptySelections } from "../fillEmptySelections";
import { sortIceHockeyBothTeamToScore } from "../../composables/sorters";
var BOT_TEAM_TO_SCORE_MARKET_TYPE_ID = "1227";
/**
 * Filter markets where marketType.id is available in cardConfig for specific sportId
 * @param markets
 * @param cardConfig
 */
export var filterMarkets = function (marketsBySport, cardConfig, specialLeagues) {
    var sportIds = Object.keys(cardConfig);
    var leagueIds = Object.keys(specialLeagues);
    var currentSportId;
    Object.keys(cardConfig).map(function (sportId) {
        var marketsInConfig = cardConfig[sportId].markets;
        marketsInConfig.map(function (m) {
            var template;
            marketsBySport[sportId].forEach(function (market) {
                currentSportId = setSportId(sportIds, market);
                template = getTemplate(market, m, specialLeagues, leagueIds);
                var shouldFillEmptySelection = ignoreFilterForSpecialMarkets(market);
                sortSpecialMarkets(!shouldFillEmptySelection, market);
                currentSportId === sportId
                    && (market.marketType.id === m.idLive || market.marketType.id === m.idPreLive) && (market.template = template)
                    && shouldFillEmptySelection && (market.selections = (fillEmptySelections(market.selections, template, cardConfig[sportId].cardType)));
            });
        });
    });
    return marketsBySport;
};
function ignoreFilterForSpecialMarkets(market) {
    return !(market.marketType.id === BOT_TEAM_TO_SCORE_MARKET_TYPE_ID && market.selections.length === 2);
}
function sortSpecialMarkets(shouldSort, market) {
    shouldSort && (market.selections = market.selections.sort(sortIceHockeyBothTeamToScore));
}
/**
 * Get specialLeague template to use
 * @param {Market} market
 * @param {MarketConfigType} m
 * @param {LeaguesConfiguration} specialLeagues are leagues that apply template, different from template in config
 * @param {string[]} leagueIds
 */
var getTemplate = function (market, m, specialLeagues, leagueIds) {
    return leagueIds && leagueIds.indexOf(market.leagueId) !== -1
        ? specialLeagues[market.leagueId]
        : m.template;
};
//# sourceMappingURL=filterMarkets.js.map